import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import communication from '@/components/communication'
import valuetestonline from '@/components/valuetestonline'
import valuetestonline_smp from '@/components/valuetestonline_smp'
import hyActivity from '@/components/hyActivity'
import hyActivityDetail from '@/components/hyActivityDetail'
import database from '@/components/database'
import perCenter from '@/components/perCenter'
import vuepdf from '@/components/vuepdf'
import shopping from '@/components/shopping'
import orderappraise from '@/components/orderAppraise'
Vue.use(Router)


let routes = [{
    path: '/',
    name: 'index',
    component: index,
    meta:{
      title:'首页'
    }
  }, {
    path: '/communication',
    name: 'communication',
    component: communication,
    meta:{
      title:'交流圈'
    }
  }, {
    path: '/valuetestonline',
    name: 'valuetestonline',
    component: valuetestonline,
    meta:{
      title:'电磁阀在线查询'
    }
  }, {
    path: '/valuetestonline_smp',
    name: 'valuetestonline_smp',
    component: valuetestonline_smp,
    meta:{
      title:'电磁阀在线查询'
    }
  }, {
    path: '/hyActivity',
    name: 'hyActivity',
    component: hyActivity,
    meta:{
      title:'行业动态'
    }
  }, {
    path: '/hyActivityDetail/:industryid/:detailId',
    name: 'hyActivityDetail',
    component: hyActivityDetail,
    meta:{
      title:'行业动态详情'
    }
  }, {
    path: '/database',
    name: 'database',
    component: database,
    meta:{
      title:'资料库'
    }
  }, {
    path: '/perCenter',
    name: 'perCenter',
    component: perCenter,
    meta:{
      title:'个人中心'
    }
  }, {
    path: '/vuepdf',
    name: 'vuepdf',
    component: vuepdf
  }, {
    path: '/shopping',
    name: 'shopping',
    component: shopping,
    meta:{
      title:'在线商城'
    }
  }, {
    path: '/orderappraise/:id',
    name: 'orderappraise',
    component: orderappraise
  }]
  // hash
const router = new Router({
  mode: 'history',
  // base: '/sample/',
  // mode: 'hash',
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title+'—'+'浙江桃园科技有限公司'
  }
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js